import AnimeUtils from '../common/utils/anime.es6';

export default class Scroll {
    constructor() {
        this.$reveals = [...document.querySelectorAll('.js-scrollreveal')];
    }

    setScrollReveal() {
        const options = { rootMargin: '0px 0px -20%' };

        for (const $reveal of this.$reveals) {
            const observer = new IntersectionObserver(this._callback, options);
            observer.observe($reveal);
        }
    }

    _callback(entries, observer) {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            // 表示クラスを追加
            entry.target.classList.add('-reveal');

            // バウンドアニメーション
            const isBounce = entry.target.classList.contains('-bounce');
            isBounce && AnimeUtils.getBounce(entry.target, 30);

            // 対象要素の監視を停止
            observer.unobserve(entry.target);
        }
    }

    setScrolling() {
        if (!document.body.classList.contains('-animationEnd')) return;

        document.body.classList.add('-scrolling');

        clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            document.body.classList.remove('-scrolling');
        }, 600);
    }
}
